import { CHAIN_PROFILES, type ChainKey } from "./generated.js";

/**
 * Die Ketten in der Reihenfolge, in der die Familie dort einkauft.
 *
 * ALDI Süd zuerst, danach Rewe und Lidl: Daniels Angabe vom 20.09.2026, dort
 * kaufen sie am meisten ein. Im Blatt "Wo kaufst du gerade ein" stehen sie
 * deshalb oben, der Rest dahinter in der Reihenfolge aus docs/laufwege.yaml.
 *
 * Süd, nicht Nord, obwohl Köln nach der Landkarte zu ALDI Nord gehört. Daniel
 * hat widersprochen, und er weiß, wo er einkauft. Die beiden haben
 * verschiedene Gangfolgen: Bei Süd liegt Fleisch gleich hinter dem Obst, bei
 * Nord kommt es erst nach der Molkerei. Nord bleibt in der Liste, nur weiter
 * unten.
 *
 * Steht bewusst hier und nicht in generated.ts: Die Datei dort wird aus
 * docs/laufwege.yaml erzeugt, und eine Gewohnheit der Familie ist keine
 * Rechercheerkenntnis über deutsche Handelsketten.
 */
export const HAEUFIGE_KETTEN: readonly ChainKey[] = ["aldi_sued", "rewe", "lidl"];

/**
 * Ein Kettenprofil, wie es in der Auswahl gebraucht wird. Bewusst eng
 * typisiert: `ChainProfile` aus der Ableitung hat `key: string`, und damit
 * ließe sich kein Laden anlegen.
 */
export interface KettenEintrag {
  readonly key: ChainKey;
  readonly name: string;
}

/** Alle Ketten, die häufigen zuerst. */
export function ketten(): readonly KettenEintrag[] {
  const alle: KettenEintrag[] = CHAIN_PROFILES.map((profil) => ({ key: profil.key, name: profil.name }));
  const haeufig = HAEUFIGE_KETTEN.map((key) => alle.find((eintrag) => eintrag.key === key)).filter(
    (eintrag): eintrag is KettenEintrag => eintrag !== undefined,
  );
  return [...haeufig, ...alle.filter((eintrag) => !HAEUFIGE_KETTEN.includes(eintrag.key))];
}
